"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceSection = void 0;
var _i18n = require("@ori/i18n");
var _constants = require("../../constants");
var _PriceSectionContent = require("./PriceSectionContent");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Displays section with current, old, and previous lowest price, mpr statement, cashback and business points.
 */
const PriceSection = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
  namespace: _constants.translationsNamespace,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceSectionContent.PriceSectionContent, {
    ...props
  })
});
exports.PriceSection = PriceSection;
//# sourceMappingURL=PriceSection.js.map